import { render, staticRenderFns } from "./ViewImg.vue?vue&type=template&id=1998562d&scoped=true"
import script from "./ViewImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewImg.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ViewImg.vue?vue&type=style&index=0&id=1998562d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998562d",
  null
  
)

export default component.exports